import "./styles.css";
import React from "react";

export default function Footer(props) {
  return (
    <a
      href="https://github.com/maryallys/weather-with-react"
      className="footer"
      target="_blank"
      rel="noopener noreferrer"
    >
      Open-source code by Maria Kandaurova
    </a>
  );
}
